import React from 'react';
import Clients from './Clients';
import { useNavigate } from 'react-router-dom';

export default function ConsultaClientes() {
  const navigate = useNavigate();

  const handleNavigate = (page, state) => {
    sessionStorage.setItem('gc_cliente', JSON.stringify(state?.client));
    navigate(`/${page}`, { state });
  };

  // Renderiza o Clients já na view de consulta (search)
  return <Clients onNavigate={handleNavigate} defaultView="search" />;
}